var _style, _path, _path2, _path3, _path4, _path5, _g, _defs, _defs2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _g3, _ellipse, _ellipse2, _g4, _path14, _path15, _path16, _circle, _circle2, _path17, _defs3, _defs4, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A59ACA;}\n\t.st1{fill:#796BAF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#A59ACA;stroke-width:2.9666;stroke-miterlimit:10;}\n\t.st4{fill:#A59ACA;stroke:#796BAF;stroke-width:2.9666;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#796BAF;stroke-width:2.9666;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#796BAF;stroke-width:1.871;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#796BAF;stroke-width:1.6153;stroke-miterlimit:10;}\n\t.st8{clip-path:url(#SVGID_2_);}\n\t.st9{clip-path:url(#SVGID_4_);fill:#3E3A39;}\n\t.st10{fill:#EF8575;}\n\t.st11{fill:#FAD4B3;}\n\t.st12{fill:none;stroke:#4D4D4D;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st13{fill:#3E3A39;}\n\t.st14{fill:none;stroke:#EF8575;stroke-width:4;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#3E3A39;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st16{fill:#C9CACA;}\n\t.st17{fill:#595757;}\n\t.st18{clip-path:url(#SVGID_6_);}\n\t.st19{clip-path:url(#SVGID_8_);fill:#3E3A39;}\n\t.st20{clip-path:url(#SVGID_8_);fill:none;stroke:#231815;stroke-width:7.0797;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.1,35.2C125.7,35.2,60,93.1,48.4,168.6c-0.3,1.9-0.6,3.8-0.8,5.8c-0.5,4.3-0.8,8.6-1,12.9 c-0.1,1.7-0.1,3.4-0.1,5.1c0,0.8,0,1.5,0,2.3c0.8,57.2,32.4,107,79.1,133.8c2.1,1.2,4.1,2.3,6.3,3.4c0.6,0.3,1.3,0.6,1.9,0.9 c0.1,0.1,0.2,0.1,0.4,0.2c21.3,10.6,45.3,16.6,70.8,16.6c26,0,50.6-6.2,72.2-17.3c2.4-1.2,4.8-2.5,7.1-3.8 c47.3-27.2,79.2-78,79.2-136.1C363.6,105.6,292.6,35.2,205.1,35.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.2,248.2v-68.4c0-8.2-6.8-15-15-15H58.2c-3.8,0-7.2,1.4-9.8,3.7c-1.2,7.8-1.8,15.8-1.8,23.9 c0,25.5,6.1,49.5,16.9,70.8h85.6C157.4,263.2,164.2,256.4,164.2,248.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.6,192.4c0-1.7,0-3.4-0.1-5.1c-0.1-4.4-0.5-8.7-1-12.9c-0.2-1.9-0.5-3.9-0.8-5.8 c-3.1-20.5-10.3-39.7-20.6-56.8h-81.9c-8.2,0-15,6.8-15,15V196c0,8.2,6.8,15,15,15h91.9c4.8,0,9.2-2.3,11.9-5.9 c0.3-3.4,0.4-6.9,0.5-10.4C363.5,193.9,363.6,193.2,363.6,192.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M181.3,349.1c7.8,1.2,15.7,1.8,23.8,1.8c8.1,0,16.1-0.6,23.8-1.8c-7.8,0.5-15.7,0.8-23.8,0.8 C197,349.9,189,349.6,181.3,349.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.9,305.8v-15.1c0-33.1-21.8-61.5-52.2-72.5v87.5H284.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334.7,194.1h-46.3c-1.7,0-3-1.3-3-3v-65.5c0-1.7,1.3-3,3-3h46.3c1.7,0,3,1.3,3,3v65.5 C337.7,192.8,336.4,194.1,334.7,194.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.6,131.3h-43.4c-2.5,0-4.4,2-4.4,4.4v48.1l19,18.9h28.9c2.5,0,4.4-2,4.4-4.4v-62.6 C327,133.3,325,131.3,322.6,131.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M273.6,185.3l18.9,18.9v-15.9c0-1.6-1.3-3-3-3H273.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M317.2,136.6c0,6.9-2.4,12.4-5.4,12.4c-3,0-5.4-5.6-5.4-12.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M306.4,161.4c0-6.9,2.4-12.4,5.4-12.4c3,0,5.4,5.6,5.4,12.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.7,138.5H310c-0.2,0-0.4-0.2-0.4-0.4v-1.2c0-0.2,0.2-0.4,0.4-0.4h3.7c0.2,0,0.4,0.2,0.4,0.4v1.2 C314.1,138.4,313.9,138.5,313.7,138.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.7,141.5H310c-0.2,0-0.4-0.2-0.4-0.4v-1.2c0-0.2,0.2-0.4,0.4-0.4h3.7c0.2,0,0.4,0.2,0.4,0.4v1.2 C314.1,141.3,313.9,141.5,313.7,141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.7,144.4H310c-0.2,0-0.4-0.2-0.4-0.4v-1.2c0-0.2,0.2-0.4,0.4-0.4h3.7c0.2,0,0.4,0.2,0.4,0.4v1.2 C314.1,144.3,313.9,144.4,313.7,144.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.7,155.5H310c-0.2,0-0.4-0.2-0.4-0.4v-1.2c0-0.2,0.2-0.4,0.4-0.4h3.7c0.2,0,0.4,0.2,0.4,0.4v1.2 C314.1,155.3,313.9,155.5,313.7,155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.7,158.5H310c-0.2,0-0.4-0.2-0.4-0.4v-1.2c0-0.2,0.2-0.4,0.4-0.4h3.7c0.2,0,0.4,0.2,0.4,0.4v1.2 C314.1,158.3,313.9,158.5,313.7,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.7,161.4H310c-0.2,0-0.4-0.2-0.4-0.4v-1.2c0-0.2,0.2-0.4,0.4-0.4h3.7c0.2,0,0.4,0.2,0.4,0.4v1.2 C314.1,161.2,313.9,161.4,313.7,161.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.1,
    cy: 143.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 290.5,
    cy: 143.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 298,
    cy: 143.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.1,
    cy: 158.1,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 290.5,
    cy: 158.1,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 298,
    cy: 158.1,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.1,
    cy: 150.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 290.5,
    cy: 150.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 298,
    cy: 150.7,
    r: 2.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 283.1,
    y: 167,
    className: "st1",
    width: 39.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.1,
    y: 170.1,
    className: "st1",
    width: 39.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.1,
    y: 173.2,
    className: "st1",
    width: 39.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.1,
    y: 176.4,
    className: "st1",
    width: 39.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M309.5,186.1c-0.3,0-0.5,0-0.8,0c-0.6-0.6-1.4-1-2.3-1c-1.9,0-3.4,1.5-3.4,3.4c0,0.1,0,0.1,0,0.2 c-1.4,1.4-2.4,3.1-2.8,5.2c-0.2,1,0.5,2,1.6,2h15.5c1,0,1.8-0.9,1.6-1.9C317.9,189.5,314.1,186.1,309.5,186.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 304.2,
    cy: 192.1,
    r: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M319,194.1c1.1-0.7,3.3-2,2.5-3.8c-0.9-2.4-0.3-4.5,1.6-5.1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30A2\\u30FC\\u30C8\\u30EF\\u30FC\\u30AF_6"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 120.3,
    y: 56.3,
    width: 169.6,
    height: 160.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 120.3,
    y: 56.3,
    width: 169.6,
    height: 160.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M289.9,140.5c0-41.7-38-84.3-84.8-84.3s-84.8,42.6-84.8,84.3c0,28.2,0,53.2,26.2,66.4c1.7-5,4-10.4,4-10.4 s2,7.9,2.9,13.4c12.2,4.5,28.9,7,51.7,7s39.5-2.5,51.7-7c0.9-5.5,2.9-13.4,2.9-13.4s2.3,5.4,4,10.4 C289.9,193.7,289.9,168.7,289.9,140.5"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.9,305.8h-52.2h-55.2h-52.2H95.3c9,8.6,19.1,16.2,30,22.5c0.2,0.1,0.3,0.2,0.5,0.3c2.3,1.3,4.7,2.6,7.1,3.8 c13.8,7,28.8,12.1,44.6,14.9c9,1.6,18.2,2.4,27.6,2.4c9.4,0,18.6-0.8,27.6-2.4c15.3-2.7,29.8-7.5,43.2-14.2c0.1-0.1,0.2-0.1,0.4-0.2 c0.6-0.3,1.3-0.6,1.9-0.9c2.1-1.1,4.2-2.2,6.3-3.4c0.2-0.1,0.3-0.2,0.5-0.3c10.9-6.3,20.9-13.9,30-22.5H284.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M232.7,305.8v-87.5c-8.6-3.1-17.9-4.8-27.6-4.8h0c-9.7,0-19,1.7-27.6,4.8v87.5H232.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M277.8,123c-3.8-37-34.9-65.9-72.8-65.9c0,0,0,0,0,0s0,0,0,0c-37.9,0-69,28.9-72.8,65.9 c-5.4,1.1-12,6.8-12,13.8c0,7.7,8.2,14,13.8,14c0.2,0,0.4,0,0.6,0c7.5,26.5,29.3,46.9,56.5,52.1v9.7c0,7.5,6.2,13.6,13.9,13.6 c7.6,0,13.9-6.1,13.9-13.6v-9.7c27.2-5.3,49.1-25.7,56.5-52.1c0.2,0,0.4,0,0.6,0c5.6,0,13.8-6.2,13.8-14 C289.9,129.8,283.3,124,277.8,123z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M258.8,305.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M151.3,305.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M258.2,273.5h21.7c5.5,0,10,4.5,10,10v0.3c0,0.5-0.1,1.1-0.1,1.6v16.4c0,2.2-1.8,4-4,4h-1.7c-2.2,0-4-1.8-4-4 v-8c-0.1,0-0.1,0-0.2,0h-1.4v8c0,2.2-1.8,4-4,4h-1.7c-2.2,0-4-1.8-4-4v-8h-1.6v8c0,2.2-1.8,4-4,4h-1.7c-2.2,0-4-1.8-4-4v-8 c-5.2-0.3-9.4-4.7-9.4-10v-0.3C248.2,278,252.7,273.5,258.2,273.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 109.4,
    y: 191.5,
    className: "st0",
    width: 13.8,
    height: 54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 218.5,
    className: "st0",
    width: 13.8,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.9,
    y: 205.4,
    className: "st0",
    width: 13.8,
    height: 40.1
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.5,218.2c-30.4,10.9-52.2,39.4-52.2,72.5v15.1h52.2V218.2z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 64.5,
    cy: 185.1,
    r: 3.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 64.5,
    cy: 195,
    r: 3.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 64.5,
    cy: 205,
    r: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.4,186.7H72.4c-0.6,0-1-0.5-1-1v-1c0-0.6,0.5-1,1-1h22.1c0.6,0,1,0.5,1,1v1C95.5,186.2,95,186.7,94.4,186.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.4,196.6H72.4c-0.6,0-1-0.5-1-1v-1c0-0.6,0.5-1,1-1h22.1c0.6,0,1,0.5,1,1v1C95.5,196.1,95,196.6,94.4,196.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.4,206.5H72.4c-0.6,0-1-0.5-1-1v-1c0-0.6,0.5-1,1-1h22.1c0.6,0,1,0.5,1,1v1C95.5,206,95,206.5,94.4,206.5z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 239.3,
    cy: 138.1,
    rx: 6.7,
    ry: 6.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 170.8,
    cy: 138.1,
    rx: 6.7,
    ry: 6.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193.2,137.5c0,9.3-10,16.9-22.4,16.9c-12.4,0-22.4-7.6-22.4-16.9c0-9.3,10-12.4,22.4-12.4 C183.2,125.1,193.2,128.2,193.2,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M216.9,137.5c0,9.3,10,16.9,22.4,16.9c12.4,0,22.4-7.6,22.4-16.9c0-9.3-10-12.4-22.4-12.4 C226.9,125.1,216.9,128.2,216.9,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193.2,137.5c7.9-3.5,15.8-3.5,23.7,0"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M192.4,174.8c9.6,5.1,17.6,4,25.4,0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M151.9,273.5h-21.7c-5.5,0-10,4.5-10,10v0.3c0,0.5,0.1,1.1,0.1,1.6v16.4c0,2.2,1.8,4,4,4h1.7c2.2,0,4-1.8,4-4 v-8c0.1,0,0.1,0,0.2,0h1.4v8c0,2.2,1.8,4,4,4h1.7c2.2,0,4-1.8,4-4v-8h1.6v8c0,2.2,1.8,4,4,4h1.7c2.2,0,4-1.8,4-4v-8 c5.2-0.3,9.4-4.7,9.4-10v-0.3C161.9,278,157.4,273.5,151.9,273.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M258.6,304.2H151.5c-2.2,0-4-1.8-4-4v-68.7c0-2.2,1.8-4,4-4h107.1c2.2,0,4,1.8,4,4v68.7 C262.6,302.4,260.8,304.2,258.6,304.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 205.1,
    cy: 265.9,
    r: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 210.1,
    cy: 262,
    r: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M260.6,308.1H149.5c-1.1,0-2-0.9-2-2v0c0-1.1,0.9-2,2-2h111.1c1.1,0,2,0.9,2,2v0 C262.6,307.2,261.7,308.1,260.6,308.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M131.3,56.3h147.3v67.4c0,0-146.5,1.7-147.3,0S131.3,82,131.3,56.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 131.3,
    y: 56.3,
    width: 147.3,
    height: 67.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M246,68.9c-14.8-8.7-29.3-12.9-41-12.3c-42.3,2.2-73,28.7-73.7,66.7c23.3-2.2,44.1-14,59.1-31.8 c23.3,20.1,47,26.3,87.5,31.5c0.8-20.9-12.1-39.9-28.1-52.2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M176.1,74.7c-11,4.9-21.4,14.6-25,26.5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.6048c5ddcfc07b5213024aec8dcef13a.svg";
export { ForwardRef as ReactComponent };